import { AppBar, Menu } from '@mui/material';
import { styled } from '@mui/styles';

export const TopBarContainer = styled(({ children, className, ...props }) => (
    <AppBar enableColorOnDark color="inherit" className={className} {...props}>
        {children}
    </AppBar>
))(({ theme: { palette } }) => ({
    backgroundColor: palette.colors.white,
    boxShadow: 'none',
    borderBottom: `1px solid ${palette.graphics.stroke}`,
    '& > .toolbar': {
        height: '65px',
        minHeight: '55px',
        justifyContent: 'space-between',

        '& .content-wrapper': {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',

            '& .logotype': {
                display: 'flex',
                alignItems: 'center',
                width: 426,
            },
            '& .toolbar': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                width: 426,
            },
        },
    },
    '&.only-logo *': {
        justifyContent: 'center',
        margin: '0',
    },
    '& > .MuiPaper-elevation4': {
        boxShadow: 'none',
    },
    '& .upgrade-button': {
        marginLeft: 10,
    },
    '& .link-text': {
        textDecoration: 'underline',
        color: '#FE5C5E',
        margin: '0 4px',
        fontWeight: 500,
        cursor: 'pointer',
    },
}));

export const FlexGrow = styled('div')(() => ({
    flexGrow: 1,
}));

export const LeftContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    '& > a:first-child': {
        marginLeft: theme.spacing(4),
    },
    '& > .zaplify-logo': {
        marginLeft: 11,
    },
}));

export const RightContainer = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
}));

export const RightAccountContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    color: theme.palette.subline,
    textAlign: 'left',
    '& > h6': {
        maxWidth: 169,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
}));

export const GuidesContainer = styled('div')(({ theme: { palette } }) => ({
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: 82,
    marginLeft: '10px',
    border: `1px solid ${palette.colors.greyInformationLight}`,
    borderRadius: 8,
    '& .button': {
        height: 38,
        width: 82,
        fontSize: 13,
        color: palette.colors.subline,
        fontWeight: 500,
        '& .icon': {
            color: palette.colors.lightGrey,
            fontSize: 18,
        },
    },
}));

export const CreditsContainer = styled('div')(({ theme: { palette } }) => ({
    display: 'flex',
    width: '242px',
    flexDirection: 'column',
    padding: '15px 20px',
    borderBottom: `1px solid ${palette.colors.greyInformationLight}`,
    '& .credits-reset': {
        marginTop: '10px',
    },
}));

export const MenuContainer = styled(({ className, ...props }) => (
    <Menu
        getContentAnchorEl={null}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        {...props}
        classes={{ paper: className }}
    />
))(({ theme }) => ({
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    width: 309,
    marginTop: '52px',
    '&.no-margin': {
        marginTop: 0,
    },
    border: `1px solid ${theme.palette.colors.greyInformationLight}`,
    boxShadow: '0px 2px 7px rgba(112, 144, 176, 0.14)',
    borderRadius: 8,
    '& .user-data-container': {
        display: 'flex',
        flexDirection: 'row',
        margin: '20px 18px 20px 15px',
        '& .user-data': {
            flexDirection: 'column',
            marginLeft: 10,
            textTransform: 'capitalize',
            cursor: 'default',
            '& .name': {
                color: theme.palette.colors.black,
                fontWeight: '500',
                fontSize: 15,
            },
            '& .company': {
                color: theme.palette.colors.greyDark,
                fontSize: 14,
            },
        },
    },
    '& .divider': {
        margin: '10px 0',
        background: theme.palette.colors.greyInformationLight,
    },
    '& .menu-item-link': {
        textDecoration: 'none',
    },
    '& .menu-item': {
        width: 290,
        height: 42,
        justifySelf: 'center',
        borderRadius: 8,
        '&:hover': {
            background: theme.palette.colors.greySelect,
        },
        '&:hover .icon': {
            color: theme.palette.colors.bluePale,
        },
        '& .text': {
            '& > span': {
                fontSize: 14,
                fontWeight: 500,
                color: theme.palette.colors.subline,
            },
            '&.MuiListItemText-root': {
                margin: 0,
            },
        },
        '& .icon': {
            color: '#96A2AC',
            '&.blocklist': {
                '& .MuiSvgIcon-root': {
                    fontSize: 20,
                },
            },
            '&.integrations': {
                '& .MuiSvgIcon-root': {
                    marginLeft: '-2px',
                },
            },
            '&.webhooks': {
                '& .MuiSvgIcon-root': {
                    marginLeft: '2px',
                    fontSize: 19,
                },
            },
            '&.blog': {
                '& .MuiSvgIcon-root': {
                    fontSize: 20,
                },
            },
            '&.help': {
                '& .MuiSvgIcon-root': {
                    fontSize: 21,
                },
            },
            '&.logout': {
                '& .MuiSvgIcon-root': {
                    paddingBottom: '4px',
                    marginLeft: '2px',
                    fontSize: 21,
                },
            },
        },
        '& .MuiListItemIcon-root': {
            minWidth: 40,
        },
    },
    '& .footer-row': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        margin: '13px 16px',
    },
    '& .privacy': {
        color: theme.palette.colors.greyDark,
        textDecorationLine: 'underline',
        fontSize: 12,
        cursor: 'pointer',
    },
    '& .build-info': {
        color: theme.palette.colors.greyDark,
        fontSize: 10,
        opacity: 0.7,
    },
}));
